module.exports = __webpack_public_path__ + "img/Syrenis-Black.c5a16eb6.svg";